import React from "react";

const BlogSix = () => {
  const blogs = [
    {
      img: "/images/keyword/1.jpg",
      title: "Tempo Traveller On Rent in Pune",
      date: "20",
      month: "June",
      link: "/tempo-traveller-on-rent-in-pune",
      content:
        "Sanavi Travels offers comfortable and reliable tempo travellers for your group trips in Pune. Our vehicles are well-maintained and come with experienced drivers for a hassle-free journey.",
    },
    {
      img: "/images/keyword/4.jpg",
      title: "Pune to Goa Tempo Traveller Hire",
      date: "15",
      month: "July",
      link: "/pune-to-goa-tempo-traveller-hire",
      content:
        "Travel from Pune to Goa in style and comfort with Sanavi Travels. Book our tempo travellers for a smooth, safe, and enjoyable road trip, with professional drivers ensuring timely pickups and drop.",
    },
    {
      img: "/images/keyword/9.jpg",
      title: "Mini Bus On Rent in Pune",
      date: "05",
      month: "August",
      link: "/mini-bus-on-rent-in-pune",
      content:
        "For corporate events, school trips, or family outings, Sanavi Travels provides mini buses on rent in Pune. Our vehicles are clean, spacious, and equipped for long journeys to ensure maximum comfort.",
    },
  ];

  return (
    <section className="blog-six section-space">
      {/* Background */}
      <div
        className="blog-six__bg"
        style={{
          backgroundImage: "url(/images/shapes/blgo-6-1.png)",
        }}
      />

      <div className="container">
        {/* Section Title */}
        <div className="sec-title sec-title--two text-center">
          <h6 className="sec-title__tagline">latest Blog</h6>
          <h3 className="sec-title__title">our latest Blog</h3>
        </div>

        {/* Blog Grid */}
        <div className="row gutter-y-30">
          {blogs.map((blog, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="blog-six__item">
                <div className="blog-six__item__image">
                  <img src={blog.img} alt={blog.title} />
                  <a
                    href={blog.link}
                    className="blog-six__item__image__hover"
                  />
                </div>

                <div className="blog-six__item__content">
                  <h3 className="blog-six__item__title">
                    <a href={blog.link} className="darkcolor">{blog.title}</a>
                  </h3>

                  <p className="blog-six__item__text">{blog.content}</p>

                

             
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="blog-six__element-one">
        <img src="/images/shapes/blog-angle-1-1.png" alt="" />
      </div>

      <div className="blog-six__element-two">
        <img src="/images/shapes/blog-angle-1-1.png" alt="" />
      </div>
    </section>
  );
};

export default BlogSix;
